import { useActor } from '@xstate/react';

import { useGlobalAppState } from '@order/GlobalAppState';
import { useBagIds } from '@order/hooks';

import type { ReorderStep } from '../../machines/Reorder.machine';
import { getValidEventKeys } from '../utils';

export const useReorderState = () => {
  const [state] = useActor(useGlobalAppState().reorderMachineRef);
  const { bagRestaurantSlug, bagAddressId } = useBagIds();

  return {
    ...getValidEventKeys(state.context),
    currentStep: state.value as ReorderStep,
    previousStep: state.context.previousStep,
    previousEvent: state.context,
    hasBag: Boolean(bagRestaurantSlug) || Boolean(bagAddressId),
  };
};
